import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2)
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1)
  }
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, py: 1, px: 3 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 4,
            color: theme => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
};

export default function ConfirmationDialog({
  open,
  handleClose,
  title,
  content,
  confirmTitle,
  onSubmit
}) {
  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      fullWidth
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleClose}
        sx={{
          fontSize: 20,
          textTransform: "uppercase",
          color: "white",
          py: 1,
          px: 3
        }}
        className="bg-primary"
      >
        {content}
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <Typography gutterBottom>{confirmTitle}</Typography>
      </DialogContent>
      <DialogActions
        sx={{
          borderTop: "1px solid rgba(224, 224, 224, 1)",
          alignItems: "start",
          justifyContent: "start"
        }}
      >
        <Button
          color="primary"
          className="customButton"
          variant="contained"
          onClick={onSubmit}
          size="small"
          sx={{ marginRight: 1, marginLeft: 1 }}
        >
          {title}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}

ConfirmationDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string,
  content: PropTypes.string,
  confirmTitle: PropTypes.string
};
